import Vue from 'vue'
const barramento = new Vue()
export default barramento



// WEBPACK FOOTER //
// ./resources/assets/js/barramento.js